import assetPath from '/app/xinglets/startpage-logged-out/entry/src/companies-section/assets/bmw-photo.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')